// TEMP GLOBAL VARIABLE
// just to get the site closed before 2025Q1 release
// TODO: remove me later

import {ref} from 'vue';
import {AvailabilityState} from 'common'
import {getStateForReporters} from '@/base/callBackend.js';

export const stateForReporters = ref<AvailabilityState>(AvailabilityState.closed);

const STATE_POLL_INTERVAL = 30_000;
let pollTimer: ReturnType<typeof setInterval> | undefined;

export async function fetchAndSetState(): Promise<void> {
    stateForReporters.value = await getStateForReporters();
}

export function startStatePolling(): void {
    stopStatePolling();
    pollTimer = setInterval(fetchAndSetState, STATE_POLL_INTERVAL);
}

export function stopStatePolling(): void {
    if (pollTimer !== undefined) {
        clearInterval(pollTimer);
        pollTimer = undefined;
    }
}
